import PageHeader from "components/PageHeader";
import { useEffect, useState } from "react";
import userService from "services/user.service";
import Table from "./components/Table";

const DataUpdate = ({ isLoggedIn }) => {
  const [extensionStatus, setExtensionStatus] = useState("");
  const [timetrackingCurrentStatus, setTimetrackingCurrentStatus] =
    useState("");
  const [timetrackingLastStatus, setTimetrackingLastStatus] = useState("");
  const [active, setActive] = useState("");

  const extensionRequest = () => {
    userService.getExtensionStatus().then(
      (response) => {
        setExtensionStatus(response?.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setExtensionStatus(_content);
      }
    );
  };

  const timetrackingCurrentRequest = () => {
    userService.getTimetrackingStatus("this").then(
      (response) => {
        setTimetrackingCurrentStatus(response?.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setTimetrackingCurrentStatus(_content);
      }
    );
  };

  const timetrackingLastRequest = () => {
    userService.getTimetrackingStatus("previous").then(
      (response) => {
        setTimetrackingLastStatus(response?.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setTimetrackingLastStatus(_content);
      }
    );
  };

  useEffect(() => {
    extensionStatus?.is_running !== "False" && setActive("");

    const extensionInterval = setInterval(() => {
      if (
        extensionStatus?.is_running !== "False" ||
        active === "extension_calls"
      ) {
        extensionRequest();
      } else {
        clearInterval(extensionInterval);
      }
    }, 2000);

    return () => {
      clearInterval(extensionInterval);
    };
  }, [isLoggedIn, extensionStatus, active]);

  useEffect(() => {
    timetrackingCurrentStatus?.is_running !== "False" && setActive("");

    const timetrackingCurrentInterval = setInterval(() => {
      if (
        timetrackingCurrentStatus?.is_running !== "False" ||
        active === "timetracking_this"
      ) {
        timetrackingCurrentRequest();
      } else {
        clearInterval(timetrackingCurrentInterval);
      }
    }, 2000);

    return () => {
      clearInterval(timetrackingCurrentInterval);
    };
  }, [isLoggedIn, timetrackingCurrentStatus, active]);

  useEffect(() => {
    timetrackingLastStatus?.is_running !== "False" && setActive("");

    const timetrackingLastInterval = setInterval(() => {
      if (
        timetrackingLastStatus?.is_running !== "False" ||
        active === "timetracking_previous"
      ) {
        timetrackingLastRequest();
      } else {
        clearInterval(timetrackingLastInterval);
      }
    }, 2000);

    return () => {
      clearInterval(timetrackingLastInterval);
    };
  }, [isLoggedIn, timetrackingLastStatus, active]);

  return (
    <>
      <div className="container">
        <PageHeader title="Data update" />
        <Table
          extensionStatus={extensionStatus}
          timetrackingCurrentStatus={timetrackingCurrentStatus}
          timetrackingLastStatus={timetrackingLastStatus}
          setActive={setActive}
        />
      </div>
    </>
  );
};

export default DataUpdate;
